// pipe (frontend wave FB): Service Agreements sidebar entry. Cloned from records-button.tsx
// (verbatim shape). Not admin-gated: the server enforces every read/write authority and the screen
// renders the localized load-error state.
import { useI18n } from '@affine/i18n';
import { DocsIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const AgreementsButton = () => {
  const t = useI18n();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  const active = useNavPrefixActive(workbench, '/agreements');

  return (
    <MenuLinkItem icon={<DocsIcon />} active={active} to={'/agreements'}>
      <span data-testid="pipe-agreements-nav">
        {t['com.affine.pipe.agreements.nav']()}
      </span>
    </MenuLinkItem>
  );
};
